module.exports = __webpack_public_path__ + "assets/img/1341587607207_.pic_hd.e5b66d11.jpg";